export class ResourceModel {
  filterMenu: any = [];
  pedagogicalModels: any = [];
  resources: any = [];
  totalCount: number = 0;
  schoolData: any;
}
